import * as React from "react";

function SvgChevronLeft(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M11.829 13.905a1.263 1.263 0 01-1.9 1.664l-5.654-6.46a1.685 1.685 0 010-2.218L9.928.431a1.263 1.263 0 011.9 1.664l-4.681 5.35a.843.843 0 000 1.11z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgChevronLeft);
export default ForwardRef;